import { useLang } from "../../i18n/LangContext";
import { Card, CardContent } from "../ui/card";
import { L } from "./lib";

export function JourneyProgressCard({ data }) {
  const { t, lang } = useLang();
  return (
    <Card className="bg-gradient-to-br from-[#10121B] to-[#161923] border-white/5">
      <CardContent className="p-5 sm:p-6 space-y-4">
        <div className="flex items-end justify-between gap-4 flex-wrap">
          <div>
            <div className="font-[Outfit] text-xl font-bold text-white">{L(data.journey.name, lang)}</div>
            <p data-testid="journey-day-counter" className="text-sm text-slate-400 mt-1">
              {t("edu.day")} {data.current_day} {t("edu.of")} {data.total_days}
            </p>
          </div>
          <span data-testid="journey-percent" className="font-[Outfit] text-3xl font-extrabold text-white">{data.percent}%</span>
        </div>
        <div className="h-2 rounded-full bg-white/10 overflow-hidden">
          <div className="h-full bg-[#10B981] transition-all duration-500" style={{ width: `${data.percent}%` }} />
        </div>
        <p className="text-xs text-slate-500">
          {data.completed_days}/{data.total_days} {t("edu.daysDone")}
          {data.eligible && data.join_day > 1 && ` · ${t("edu.joinedDay")} ${data.join_day}`}
        </p>
        {!data.eligible && (
          <p data-testid="journey-ineligible-reason" className="text-xs text-amber-300">
            {data.ineligible_reason || t("edu.notEligible")}
          </p>
        )}
      </CardContent>
    </Card>
  );
}
